export const CustomStyles = (errors) => ({
  control: (styles) => ({
    ...styles,
    height: 60,
    padding: '18px 10px 18px 18px',
    borderRadius: 6,
    border: `1px solid ${errors?.projectDuration ? '#ff0000' : '#d5d9e7'}`,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
  }),
  placeholder: (styles) => ({
    ...styles,
    fontSize: 16,
    color: '#D5D9E7',
  }),
});
